import { dlg } from '../dlg';
import { PostTag } from '../components/posting';
import { state } from '../services/state';
import { post_status_name, PostStatus, PostType, PostTypeMap } from './postingDlg';
import { openActionDlg } from './actionDlg';
import { openClientDlg } from './clientDlg';
import { formateDateStr, format_phone, removeFromArray, get_loc_desc } from '../utils/utils';
import { api } from '../services/api';
import { makeAutoObservable } from 'mobx';
import { ClientActions } from '../components/client_actions';
import { make_req } from '../services/api2';

function ViewPostDlg(z: { p: IPost }) {
	let el: HTMLDivElement;
	const p = z.p;
	const l = makeAutoObservable({ actions: [] as IAction[] });

	let help_offered = p.type === PostType.help_offered;
	let can_edit = false;
	if (p.user_id == state.user?.id) {
		can_edit = true;
	} else if (state.is_org_user && state.user_org.id === p.id) {
		can_edit = true;
	}

	async function edit_posting() {
		dlg.close(el);
		state.editPost(p.id);
	}

	async function edit_action(action: IAction) {
		let is_new = false;
		if (!action) {
			is_new = true;
			action = {
				post_id: p.id,
				user_id: state.user.id,
				client_id: p.user_id,
				info: '',
				type: '',
				resource: null,
				pending: true,
				complete: false,
				amount: null,
				action_date: new Date().toISOString(),
				org_id: state.user_org?.id || null
			};
		}

		await openActionDlg(action);
		if (is_new) {
			if (action.id) l.actions.push(action);
		} else if (!action.id) {
			removeFromArray(action, l.actions);
		}
	}

	let can_action = PostTypeMap.get(p.type).can_action;
	if (can_action) {
		api.get_actions({ client_id: p.user_id }).then((r) => (l.actions = r));
	}

	function set_status(status: PostStatus) {
		p.status = status;
		make_req('set_post_status', { id: p.id, status: p.status });
	}

	return (
		<div class="dlgbg" ref={el}>
			<div class="dlg" style={{ width: '500px' }}>
				<div class="dlg-header center">
					<PostTag t={p.type} />
					<div class="grow" style={{}}>
						{p.title}
					</div>
					{formateDateStr(p.post_date)}
				</div>
				<div class="dlg-content">
					<div class="row">
						<label>Description</label>
						<div class="valuebox">{p.description}</div>
					</div>
					{p.org && (
						<div class="row">
							<label>Organization</label>
							<div class="valuebox">{p.org.name}</div>
						</div>
					)}
					{(state.is_provider || !can_action) && (
						<div class="row">
							<label>Name</label>
							<div class="valuebox">{p.name}</div>
						</div>
					)}
					{(state.is_provider || !can_action) && (
						<div class="row">
							<label>Phone Number</label>
							<div class="valuebox">{format_phone(p.phone)}</div>
						</div>
					)}
					<div class="row">
						<label>Location</label>
						<div class="valuebox">{get_loc_desc(p.location)}</div>
					</div>
					{p.tags.length && (
						<div class="row">
							<label>Tags</label>
							<div class="valuebox">{p.tags.join(', ')}</div>
						</div>
					)}
					{p.expire_date && (
						<div class="row">
							<label>Expiration: {formateDateStr(p.expire_date)}</label>
							{/* <div class="valuebox">{formateDateStr(l.expire_date)}</div> */}
						</div>
					)}
					{state.is_provider && can_action && (
						<div class="row">
							<label>Status</label>
							{/* <select value={p.status} onChange={(e) => (p.status = parseInt(e.target.value) || null)}>
								<option value={null}></option>
								<option value={PostStatus.pending}>Pending Action</option>
								<option value={PostStatus.completed}>Complete</option>
							</select> */}
							<div class="flex gap20 center">
								<label style={{ cursor: 'pointer' }}>
									Pending&nbsp;
									<input checked={p.status == null} type="radio" onClick={(e) => set_status(null)} />
								</label>
								<label style={{ cursor: 'pointer' }}>
									Complete&nbsp;
									<input
										checked={p.status == PostStatus.completed}
										type="radio"
										onClick={(e) => set_status(PostStatus.completed)}
									/>
								</label>
								<label style={{ cursor: 'pointer' }}>
									Help in progress&nbsp;
									<input
										checked={p.status == PostStatus.pending}
										type="radio"
										onClick={(e) => set_status(PostStatus.pending)}
									/>
								</label>
								{/* <input
									style={{ width: '100px' }}
									readOnly={true}
									value={post_status_name.get(p.status) || 'not set'}
								/>
								<a onClick={(e) => (p.status = PostStatus.pending)}>Mark Pending</a>
								<a onClick={(e) => (p.status = PostStatus.completed)}>Mark Completed</a>
								<a onClick={(e) => (p.status = null)}>Reset</a> */}
							</div>
						</div>
					)}
					{l.actions.length && state.is_provider && <ClientActions actions={l.actions} />}
				</div>
				<div class="dlg-footer">
					{!state.has_user && <span style={{ color: 'royalblue' }}>Sign in for contact info</span>}
					{state.is_provider && can_action && (
						<button
							id="bt_view_post_client_info"
							onClick={(e) => {
								openClientDlg(p.user_id);
								dlg.close(el);
							}}
						>
							Client Info
						</button>
					)}
					{can_edit && (
						<button id="bt_view_post_edit" onclick={edit_posting}>
							Edit
						</button>
					)}
					<span class="grow"></span>
					{state.is_provider && can_action && (
						<button id="bt_view_post_add_action" onClick={(e) => edit_action(null)} class="primary">
							Add Action
						</button>
					)}
					<button id="bt_view_post_close" onClick={(e) => dlg.close(el)}>
						Close
					</button>
				</div>
			</div>
		</div>
	);
}

export function openViewPostDlg(p: IPost): Promise<IPost> {
	return dlg.open(ViewPostDlg, { p });
}
